
<el-container class="screen-parameters screen-parameters-fullHeight services">
  <el-row class="services-panel black-inputs black-inputs_2">
    <el-col :span="20" :offset="2" class="services-container">
      <div class="nav-toggle" @click="showHideScreenReviews">
        <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
      </div>
      <div class="screen-title">Configuration demande d’avis</div>
      <div class="screen-block">
        <div class="screen-block">
          <el-row>
            <el-col :span="12">
              <span style="margin-right: 10px">Envoi automatique activé :</span>
              <el-switch v-model="restoReviews" active-color="#00cec0" inactive-color="#e95d5d">
              </el-switch>
            </el-col>
          </el-row>
        </div>
        <div class="screen-block">
          <el-row>
            <el-col :span="6" class="screen-label">Message personnalisé première partie :</el-col>
            <el-col :span="18">
              <el-input v-model="restoReviewsTxt1" :autosize="{ minRows: 3 }" type="textarea"></el-input>
            </el-col>
          </el-row>
        </div>
        <div class="screen-block">
          <el-row>
            <el-col :span="6" class="screen-label">Message personnalisé seconde partie :</el-col>
            <el-col :span="18">
              <el-input v-model="restoReviewsTxt2" :autosize="{ minRows: 3 }" type="textarea"></el-input>
            </el-col>
          </el-row>
        </div>
        <div class="screen-block">
          <div class="reviewsLinks-title">Liens</div>
          <div class="reviewsLink" v-for="(link, i) in restoReviewsLinks" :key="i">
            <el-row>
              <el-col :span="6" class="screen-label">Intitulé du lien :</el-col>
              <el-col :span="18">
                <el-input v-model="link.title" placeholder="Cliquez pour laisser un avis sur tripadvisor"></el-input>
              </el-col>
              <el-col :span="6" class="screen-label">Lien :</el-col>
              <el-col :span="18">
                <el-input v-model="link.link" placeholder="https://url-du-site-pour-les-avis.com/url/..."></el-input>
              </el-col>
              <el-col>
                <div @click="deleteLink(i)" class="reviewsLink-delete">
                  Supprimer le lien
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="screen-block">
          <el-button class="dark" type="primary" @click="addLink">Ajouter un lien</el-button>
        </div>
        <el-row>
          <el-col :span="7" :offset="9">
            <el-button class="dark" type="primary" @click="showHideScreenReviews">Annuler</el-button>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-button type="primary" @click="validModifications()">Valider</el-button>
          </el-col>
        </el-row>
      </div>
    </el-col>
  </el-row>
</el-container>
